/**
 * Source de vérité unique pour l'offre de lancement -20%.
 *
 * Pour réactiver l'offre :
 *   - PROMO_START_TS = "now" (UTC ISO)
 *   - PROMO_END_TS   = "now + 7 jours"
 * Tout le site (bannière, prix /nos-abonnements, mentions Home, etc.) bascule automatiquement.
 *
 * Tarifs commerciaux (manuels — pas de calcul automatique).
 */
export const PROMO_START_TS = '2026-05-05T00:00:00Z';
export const PROMO_END_TS   = '2026-05-12T23:59:59Z';

export const PROMO_DISCOUNT_LABEL = '−20% offre de lancement';

export const PLAN_PRICING = {
  essentielle:    { regular: 99,  launch: 79  },
  evolution:      { regular: 169, launch: 135 },
  transformation: { regular: 219, launch: 175 },
};

export const PRIVATE_CLASS_PRICE = 70;

export function isPromoActive(now = Date.now()) {
  const start = new Date(PROMO_START_TS).getTime();
  const end   = new Date(PROMO_END_TS).getTime();
  return now >= start && now <= end;
}
